import { useEffect, useState } from 'react';

export const getAllQueryParams = (): URLSearchParams => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return params;
};

export const useQueryString = (param: string, fallback = ''): string => {
  const params = getAllQueryParams();
  const value = params.get(param);
  return value ?? fallback;
};

export const getHashParams = (): URLSearchParams => {
  // location.hash carries a leading '#'; strip it before parsing.
  return new URLSearchParams(window.location.hash.replace(/^#/, ''));
};

/**
 * Read a single-use credential delivered in the URL fragment (e.g. the password
 * reset_token), then scrub the fragment from the address bar and history.
 *
 * The fragment is used instead of the query string so the value is never sent to
 * the SSO web server / CDN / proxies and so never lands in their access logs
 * (CWE-598). The token is captured once on first render — the scrub must not race
 * the read — and stripped via history.replaceState so it isn't retained in
 * browser history either.
 */
export const useTokenFromHash = (param: string, fallback = ''): string => {
  const [token] = useState(() => getHashParams().get(param) ?? fallback);

  useEffect(() => {
    if (window.location.hash) {
      const { pathname, search } = window.location;
      window.history.replaceState(null, '', `${pathname}${search}`);
    }
  }, []);

  return token;
};
